import { useState } from "react";
import PlayCircleRoundedIcon from "@mui/icons-material/PlayCircleRounded";
import Tooltip from "@mui/material/Tooltip";
import "react-h5-audio-player/lib/styles.css";
import PlayerOverlay from "./MuxPlayerOverlay";

function MuxPlayAction({ item }: any) {
  const [open, setOpen] = useState(false);

  const getPlaybackId = () => {
    if (item.mux_playback_id) return item.mux_playback_id;
  };

  const playbackId = getPlaybackId();

  if (!playbackId) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
    <Tooltip title="Play Talktape" enterDelay={0} leaveDelay={0}>
      <span>
      <PlayCircleRoundedIcon
        className="music-icon play"
        onClick={handleClick}
        sx={{ cursor: "pointer", color: "#1976d2" }}
      />
      </span>
      </Tooltip>

      {open && (
        <PlayerOverlay
          open={open}
          onClose={() => setOpen(false)}
          mux_playback_id={playbackId}
          talktape_video_title={item.talktape_video_title || item.song_title || item.fileName}
        />
      )}
    </>
  );
}

export default MuxPlayAction;